import { render, staticRenderFns } from "./PopupSelect.vue?vue&type=template&id=3f4b007c&"
import script from "./PopupSelect.vue?vue&type=script&lang=ts&"
export * from "./PopupSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PopupSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports